import { jsx } from "@builder.io/qwik/jsx-runtime";
import { component$, useContext, useComputed$, Slot } from "@builder.io/qwik";
import { TAB_ID_PREFIX } from "./tab.qwik.mjs";
import { tabsContextId } from "./tabs-context-id.qwik.mjs";
const TAB_PANEL_ID_PREFIX = "_tabpanel_";
const HTabPanel = component$(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  ({ label, _tabId, _extraClass, ...props }) => {
    const contextService = useContext(tabsContextId);
    const fullPanelElementId = contextService.tabsPrefix + TAB_PANEL_ID_PREFIX + _tabId;
    const fullTabElementId = contextService.tabsPrefix + TAB_ID_PREFIX + _tabId;
    const isSelectedSig = useComputed$(() => {
      return contextService.selectedTabIdSig.value === _tabId;
    });
    return /* @__PURE__ */ jsx("div", {
      ...props,
      id: fullPanelElementId,
      "aria-labelledby": fullTabElementId,
      role: "tabpanel",
      tabIndex: 0,
      hidden: !isSelectedSig.value,
      children: /* @__PURE__ */ jsx(Slot, {})
    });
  }
);
export {
  HTabPanel,
  TAB_PANEL_ID_PREFIX
};
